import { render } from "./ui-stickynote.vue?vue&type=template&id=0d395a0e"
import script from "./ui-stickynote.vue?vue&type=script&lang=js"
export * from "./ui-stickynote.vue?vue&type=script&lang=js"

import "./ui-stickynote.vue?vue&type=style&index=0&id=0d395a0e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__